import './SessionTimer.scss';

import moment from 'moment';

import React, { Fragment, useRef, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LFEBeaconButton, LFEBeaconModal } from 'components/shared/LFEBeaconComponents';
import { getExternalBasePath } from 'config/EnvironmentConfig';
import { getSessionTimerTimestamp } from 'state/sessionTimer/SessionTimerSelectors';
import { updateSessionTimestamp } from 'state/sessionTimer/SessionTimerActions';
import Store from 'state/Store';

const SessionTimer = ({ stepStartTime }) => {
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const inactiveInterval = useRef();
  let timer = (timeString) => {
    inactiveInterval.current = setInterval(() => {
      const maxTime = 15; //Maximum number of minutes till logout
      const warningTime = 13; //Number of minutes passed to show warning

      const diff = moment.duration(moment().diff(moment(timeString)));
      //How many minutes have passed since last timestamp
      const minutesPast = diff.minutes();
      const secondsPast = (60 - diff.seconds()) - 1;
      const minutesToTimeout = (maxTime - minutesPast) - 1;

      //Show warning modal if no activity in 12 minutes
      if (warningTime < minutesPast || warningTime === minutesPast) {
        setShowModal(true);
        setMinutes(minutesToTimeout);
        setSeconds(secondsPast);
      }

      //Logout if minutes from last timestamp equals maximum idle time
      if (minutesPast === maxTime) {
        window && window.top && window.top.location.replace(getExternalBasePath() + '/personal-investing/resources/planning/life-events/inherited-account/death-notification.html');
        clearInterval(inactiveInterval.current);
        setShowModal(true);
      }
    }, 1000);
  };

  useEffect(() => {
    timer(stepStartTime);

    return () => clearInterval(inactiveInterval.current);

  }, [stepStartTime]);

  const renderTime = () => {
    const minutesDisplay = minutes < 10 ? `0${minutes}` : minutes;
    const secondsDisplay = seconds < 10 ? `0${seconds}` : seconds;

    if(minutes < 0) {
      return '00:00 seconds';
    }

    return minutes > 0
      ? `${minutesDisplay}:${secondsDisplay} minutes`
      : `${minutesDisplay}:${secondsDisplay} seconds`;
  };

  const logout = () => {
    window && window.top && window.top.location.replace(getExternalBasePath() + '/personal-investing/resources/planning/life-events/inherited-account/death-notification.html');
  };

  const handleReset = () => {
    const modal = document.getElementById('timeoutModal');
    if (modal) {
      modal.close();
    }
    Store.dispatch(updateSessionTimestamp());
    clearInterval(inactiveInterval.current)
    setShowModal(false);
  };
  return showModal
    ? (
    <div className="lfe-beacon-modal-wrapper">
      <LFEBeaconModal id="timeoutModal"
                      title="Your session is about to expire"
                      size="normal"
                      open="true"
                      removeCloseButton="true">
        <h2 className="beacon-modal__title">Your session is about to expire</h2>
        <p className="beacon-modal__description">
          {`Your session will expire in approximately ${renderTime()} If your session expires, the notification information you’ve entered will not be saved.To continue your session, click “Keep Me Online”. If you would like to end your session now, click “Cancel”.`} 
        </p>
        <div className="action-buttons">
          <LFEBeaconButton slot="action-zone"
                           variant="tertiary"
                           label="Cancel"
                           onBeaconClick={() => logout()}
          />
          <LFEBeaconButton slot="action-zone"
                           label="Keep Me Online"
                           onBeaconClick={() => handleReset()}
          />
        </div>
      </LFEBeaconModal>
    </div>
    )
    : (
    <Fragment />
    );
};

const mapStateToProps = state => ({
  stepStartTime: getSessionTimerTimestamp(state)
});

export default connect(mapStateToProps)(SessionTimer);